var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.internalValue)?_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.internalValue)))]):_vm._e(),_vm._v(" "),(!_vm.internalValue)?_c('span',[_vm._v("-")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4292407a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Date.vue
// module id = 855
// module chunks = 0